/**
 * Order Sources API Types
 *
 * Type definitions for order source data from Rails backend.
 */

// Mirrors OrderSource::FeeTypes (app/models/order_source.rb).
export const FeeTypes = {
  FLAT: 'Flat',
  PERCENTAGE: 'Percentage',
} as const;

export type FeeType = (typeof FeeTypes)[keyof typeof FeeTypes];

// Canonical shape returned by /api/order_sources (list, show, create, update).
export interface OrderSource {
  id: number;
  name: string;
  description: string | null;
  active: boolean;
  papercut_sales_order_source_id: number | null;
  fee: number | null;
  fee_type: FeeType | null;
  created_at: string;
  updated_at: string;
}

export interface OrderSourcesListResponse {
  order_sources: OrderSource[];
  pagination: {
    page: number;
    per_page: number;
    total: number;
    sort_by: string;
    sort_direction: string;
  };
  total_unfiltered: number;
}

export interface OrderSourceShowResponse {
  order_source: OrderSource;
}

export type OrderSourceApiStatus = 'active' | 'inactive';

export interface FetchOrderSourcesListParams {
  status?: OrderSourceApiStatus;
  q?: string;
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export interface CreateOrderSourcePayload {
  name: string;
  description?: string | null;
  fee?: number | null;
  fee_type?: FeeType | null;
}

export interface UpdateOrderSourcePayload {
  name?: string;
  description?: string | null;
  fee?: number | null;
  fee_type?: FeeType | null;
}
